import { AlertTriangle, LogOut } from 'lucide-react';
import type React from 'react';

import { Button } from '@docuid/ui/components/ui/button';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@docuid/ui/components/ui/sheet';

interface LogoutDialogProperties {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

const LogoutDialog: React.FC<LogoutDialogProperties> = ({ isOpen, onOpenChange, onConfirm }) => {
  return (
    <Sheet open={isOpen} onOpenChange={onOpenChange}>
      <SheetContent
        side="bottom"
        className="border-border bg-card text-card-foreground w-full rounded-t-2xl border-t px-0 pb-8"
      >
        <SheetHeader className="relative px-5 pb-2">
          <SheetTitle className="text-foreground flex items-center gap-2 text-base font-bold">
            <LogOut className="text-destructive h-5 w-5" />
            Sign Out
          </SheetTitle>
        </SheetHeader>

        <div className="flex flex-col gap-4 px-5 pt-2">
          <p className="text-muted-foreground text-xs">
            Are you sure you want to sign out of your DocuID account?
          </p>

          <div className="bg-destructive/10 border-destructive/20 text-destructive flex items-start gap-2.5 rounded-xl border p-3 text-[11px] font-medium">
            <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" />
            <div className="flex flex-col">
              <span>Clear Session Cache</span>
              <span className="text-muted-foreground mt-0.5 text-[10px]">
                Signing out clears local document session data and biometric keys to protect your
                security.
              </span>
            </div>
          </div>

          <div className="mt-1 flex gap-2">
            <Button
              variant="outline"
              onClick={() => {
                onOpenChange(false);
              }}
              className="border-border bg-card text-foreground hover:bg-accent/10 h-11 flex-1 rounded-xl text-sm font-semibold"
            >
              Cancel
            </Button>
            <Button
              onClick={onConfirm}
              className="bg-destructive hover:bg-destructive/90 h-11 flex-1 rounded-xl text-sm font-semibold text-white transition-all active:scale-[0.98]"
            >
              Sign Out
            </Button>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default LogoutDialog;
